export const caseOwnerId = 'caseOwnerId'
export const currentOwnerId = 'currentOwnerId'
export const currentAssigneeId = 'currentAssigneeId'
export const teamMemberId = 'teamMemberId'
export const ownershipType = 'ownershipType'
